import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IAllFoundPointsVL, IPoint, VectorLayersReducer } from 'types/mainPage';

export const initialAllPoints = {
  items: {} as { [key: string]: IPoint[] },
  point_radius: 0,
  distance: 0,
  distance_min: 0,
  z_level_min: 0,
  z_level_max: 0,
  oked_colors: {},
};

const initialState: VectorLayersReducer = {
  foundPoints: [],
  allFoundPoints: initialAllPoints,
  showPoints: false,
  needUpdateClusterInfo: false,
};

export const vectorLayersSlice = createSlice({
  initialState,
  name: 'vectorLayers',
  reducers: {
    setFoundPoints(state, action: PayloadAction<IPoint[]>) {
      state.foundPoints = action.payload;
    },
    setAllFoundPoints(state, action: PayloadAction<IAllFoundPointsVL>) {
      state.allFoundPoints = action.payload;
    },
    toggleNeedUpdate(state, action: PayloadAction<boolean>) {
      state.needUpdateClusterInfo = action.payload;
    },
    toggleShowPoints(state, action: PayloadAction<boolean>) {
      state.showPoints = action.payload;
    },
    resetVectorLayerData(state) {
      state.foundPoints = [];
      state.allFoundPoints = initialAllPoints;
      state.showPoints = false;
    },
    resetVectorLayers() {
      return initialState;
    },
  },
});

export default vectorLayersSlice.reducer;
